module.exports = __webpack_public_path__ + "img/commited.05595c1b.svg";